import { render, staticRenderFns } from "./linkHistory.vue?vue&type=template&id=fb39799e"
import script from "./linkHistory.vue?vue&type=script&lang=js"
export * from "./linkHistory.vue?vue&type=script&lang=js"
import style0 from "./linkHistory.vue?vue&type=style&index=0&id=fb39799e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports